
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
    Component,
    OnInit,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
    Inject,
    ElementRef
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { CommonService } from '../../services';
import { Windows11AssessmentService } from '../../services/windows-11-assessment.service';
import { NgProgressService } from '../../services/ngProgress.service';
import { Subscription } from 'rxjs';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HardwareReadinessModel } from '../../models/Windows11Readiness.model';
//import { debug } from 'console';

@Component({
    selector: 'app-windows-11-report-top',
    templateUrl: './windows-11-report-top.component.html',
    styleUrls: ['./windows-11-report-top.component.css'],
})
export class Windows11ReportTopComponent implements OnInit, OnDestroy {
    @ViewChild("ParentWrapper", { static: false }) parentWrapper: ElementRef;

    created = false;
    loadContent = false;
    columnData: string[] = [];
    @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
    @ViewChild('brandSelect') private brandSelect: NgModel;

    // windowsReadeadinessActiveRouter: Subscription;
    // windowsReadeadinessActiveRouterParent: Subscription;
    // windowsReadeadinessRouterParaChange: Subscription;

    isLoading = true;
    percent: number = 0;
    upgradeEligibility0: number = 0;
    upgradeEligibility1: number = 0;
    upgradeEligibility2: number = 0;
    upgradeEligibility3: number = 0;
    totalDevices: number = 0;  
    
    laodingCongratulation = false;
    notFullyCongratulation = false;

    readinessCount: Record<string, number> = {};
    upgradeCount: Record<string, number> = {};
    returnCodeCount: Record<string, number> = {};
    modelType: 'windowsFeature' | 'workFromAnywhere' | 'hardwareReadiness' | null = null;
    //modelType: 'windows' | 'work' | 'hardware' | null = null;
    allDevicesUpgradedToWin11: boolean = false;
    constructor(
        private activeRouter: ActivatedRoute,
        public ngProgress: NgProgressService,
        private router: Router,
        // private commonService: CommonService,
        private windows11AssessmentService: Windows11AssessmentService,
        @Inject(ViewContainerRef) private viewContainerRef
    ) {
      this.windows11AssessmentService.win11ModelType$.subscribe(type => {
        this.modelType = type;
      });
    }

    ngOnInit() {
        // this.windowsReadeadinessRouterParaChange = this.activeRouter.paramMap.subscribe(param => {
         
         //0 -	Low risk  1-Medium risk 2-High risk 3-Replace device 4-Upgraded 5-Unknown
           if(this.modelType == 'windowsFeature')
           {
            this.windows11AssessmentService.windowsFeature$.subscribe(data => {
                if (data)  
                {
                    //const filteredData = data.filter(d => d.OSVersion < this.windows11AssessmentService.windows11OsVersion);
                    const devicesOnWindows11 = data.filter(d => this.windows11AssessmentService.isOSVersionGreater(d.OSVersion)).length;
                    
                    this.readinessCount = this.getGroupedCount(data.filter(d => d.ReadinessStatus !== undefined &&
                     !this.windows11AssessmentService.isOSVersionGreater(d.OSVersion)), 'ReadinessStatus');
                     this.upgradeEligibility0 =  devicesOnWindows11 || 0;
                    //this.upgradeEligibility0 = this.readinessCount['4'] + upgradedCount || 0;
                    this.upgradeEligibility1 = (typeof this.readinessCount['0'] === 'number' ? this.readinessCount['0'] : 0) +
                      (typeof this.readinessCount['1'] === 'number' ? this.readinessCount['1'] : 0) +
                      (typeof this.readinessCount['2'] === 'number' ? this.readinessCount['2'] : 0) +
                      (typeof this.readinessCount['5'] === 'number' ? this.readinessCount['5'] : 0) || 0;
                    this.upgradeEligibility2 = this.readinessCount['3'] || 0;
                    this.totalDevices = this.upgradeEligibility0 + this.upgradeEligibility1 + this.upgradeEligibility2 + this.upgradeEligibility3;
                    if(this.totalDevices == this.upgradeEligibility0) {
                      this.windows11AssessmentService.setAllDevicesUpgradedToWin11(true);
                    }
                }
              });
            }
            else if(this.modelType == 'workFromAnywhere') {//0-Upgraded 1-Unknown 2-Not capable  3-Capable
              this.windows11AssessmentService.workAnywhere$.subscribe(data => {
                if (data) {
                  const devicesOnWindows11 = data.filter(d => this.windows11AssessmentService.isOSVersionGreater(d.OSVersion)).length;
                  this.upgradeCount = this.getGroupedCount(data.filter(d => d.UpgradeEligibility !== undefined &&
                                !this.windows11AssessmentService.isOSVersionGreater(d.OSVersion)), 'UpgradeEligibility');
                  //this.upgradeCount = this.getGroupedCount(data.filter(d => d.UpgradeEligibility !== undefined), 'UpgradeEligibility');
                    this.upgradeEligibility0 = devicesOnWindows11 || 0;
                    //this.upgradeEligibility0 = this.upgradeCount['0'] || 0;
                    this.upgradeEligibility1 = this.upgradeCount['1'] || 0;
                    this.upgradeEligibility2 = this.upgradeCount['2'] || 0;
                    this.upgradeEligibility3 = this.upgradeCount['3'] || 0;
                    this.totalDevices = this.upgradeEligibility0 + this.upgradeEligibility1 + this.upgradeEligibility2 + this.upgradeEligibility3;
                    if(this.totalDevices == this.upgradeEligibility0) {
                      this.windows11AssessmentService.setAllDevicesUpgradedToWin11(true);
                    }
                  }
              });
            }//-2 - Failed To Run, -1 - UnDetermined, 0 - Capable, 1 - Not Capable  
            else if(this.modelType == 'hardwareReadiness') {  
              this.windows11AssessmentService.hardwareReadiness$.subscribe(data => {
                if (data)  {
                  data= data.map(d => ({
                    DeviceName: d.DeviceName,
                    OSVersion: this.windows11AssessmentService.extractNumericOSVersion(d.OSVersion), // Replace OSVersion with the extracted numeric part
                    Result : d.Result
                  })).filter(d => Number(d.OSVersion.split('.').join('')) > 0); // Ensure valid numeric OSVersion

                  const devicesOnWindows11 = data.filter(d => this.windows11AssessmentService.isOSVersionGreater(d.OSVersion)).length;
                  data = data.filter(d => !this.windows11AssessmentService.isOSVersionGreater(d.OSVersion));
                  const groupedCounts = this.getGroupedReturnCount(data, 'returnCode');

                  // Assign counts to upgradeEligibility variables
                  //this.upgradeEligibility0 = groupedCounts['0'] || 0;
                  this.upgradeEligibility1 = ((typeof groupedCounts['-2'] === 'number' ? groupedCounts['-2'] : 0) +
                                              (typeof groupedCounts['-1'] === 'number' ? groupedCounts['-1'] : 0))
                  this.upgradeEligibility2 = groupedCounts['1'] || 0;
                  this.upgradeEligibility0 = devicesOnWindows11 || 0;
                  this.upgradeEligibility3 = groupedCounts['0'] || 0;
              
                  // Calculate total devices
                  this.totalDevices = this.upgradeEligibility0 + this.upgradeEligibility1 + this.upgradeEligibility2 + this.upgradeEligibility3;
              
                    if(this.totalDevices == this.upgradeEligibility0) {
                      this.windows11AssessmentService.setAllDevicesUpgradedToWin11(true);
                    }
                }
              });
            }

            this.windows11AssessmentService.allDevicesUpgradedToWin11$.subscribe(value => {
              this.allDevicesUpgradedToWin11 = value;
              (value) ? this.laodingCongratulation = true : this.laodingCongratulation = false;
             // console.log('All Devices Upgraded to Win11:', value);
            });
    }

    getGroupedCount(arr: any[], key: string): Record<string, number> {
        return arr.reduce((acc, item) => {
          const val = item[key];
          acc[val] = (acc[val] || 0) + 1;
          return acc;
        }, {} as Record<string, number>);
      }
    
      getGroupedReturnCount(arr: any[], key: string): Record<string, number> {
        return arr.reduce((acc, item, index) => {
          try {
            // Debugging: Log the item and its Result field
            //console.log(`Processing item at index ${index}:`, item);
      
            // Check if the Result field exists and is a string
            if (item && item.Result) {
              let parsedResult;
              if (typeof item.Result === 'string') {
                parsedResult = JSON.parse(item.Result);
              } else if (typeof item.Result === 'object') {
                parsedResult = item.Result; // Assume it's already parsed
              } else {
               // console.warn(`Skipping item at index ${index} due to unsupported Result type:`, typeof item.Result);
                acc['invalid'] = (acc['invalid'] || 0) + 1;
                return acc;
              }
            
              // Extract the specified key (e.g., returnCode)
              const value = String(parsedResult[key] ?? 'invalid');
            
              // Increment the count for the extracted value
              acc[value] = (acc[value] || 0) + 1;
            } else {
              //console.warn(`Skipping item at index ${index} due to missing Result field:`, item);
              acc['invalid'] = (acc['invalid'] || 0) + 1;
            }
          } catch (error) {
            //console.error(`Error parsing Result at index ${index}:`, error);
            acc['invalid'] = (acc['invalid'] || 0) + 1; // Handle invalid JSON
          }
          return acc;
        }, {} as Record<string, number>);
      }
      
      getKeys(obj: Record<string, number>): string[] {
        return Object.keys(obj);
      }

    fillData() {
    }

    navigateToReportExtract(){
        this.router.navigate(['/windows-11-readiness/windows-11-report/windows-11-report-extract']);
    }
    getPercentage(count): number {
        
        if(count > -1){
            //console.log("Total Devices", this.totalDevices);
            return this.totalDevices > 0 ? parseFloat(((count / this.totalDevices) * 100).toFixed(2)) : 0.00;
        }
        return -1;
    }


    ngOnDestroy(): void {
        // this.closesub$.unsubscribe();
    }

    close() {
        this.router.navigateByUrl('/windows-11-readiness');
    }


    onLoading(currentLoadingStatus: boolean) {
        this.ngProgress.done();
        this.loadContent = !currentLoadingStatus;
    }
    onNavigate(id, url) {
        
        window.open(url, '_blank');
    }
}